import { render } from "./CosmicEvents.vue?vue&type=template&id=7fb4be94&scoped=true"
import script from "./CosmicEvents.vue?vue&type=script&lang=js"
export * from "./CosmicEvents.vue?vue&type=script&lang=js"

import "./CosmicEvents.vue?vue&type=style&index=0&id=7fb4be94&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb4be94"]])

export default __exports__